export const LOCATIONS = [
  {
    slug: "clearwater-fl",
    name: "Clearwater",
    short: "From Countryside to the Island Estates, weekly pool care across Clearwater.",
    intro: "Clearwater is one of the largest pool markets in Pinellas County, and we serve homeowners across the whole city — from the established neighborhoods of Countryside and Feather Sound to Island Estates and the streets near downtown.",
    local: "Inland Clearwater pools often battle oak and pine debris, while pools closer to the Gulf deal with salt air that wears on equipment. Our weekly routes cover both, with water chemistry adjusted for what your specific backyard throws at it.",
  },
  {
    slug: "clearwater-beach-fl",
    name: "Clearwater Beach",
    short: "Salt air, sand, and high-use pools — cared for weekly on the beach.",
    intro: "Clearwater Beach pools work hard. Between salt spray, blowing sand, and heavy bather loads from family and guests, beach pools need consistent, professional attention to stay clear.",
    local: "We service residential pools across Clearwater Beach and understand what coastal exposure does to heaters, pumps, and finishes — and how to stay ahead of it with the right chemistry and equipment care.",
  },
  {
    slug: "largo-fl",
    name: "Largo",
    short: "Dependable weekly pool service throughout Largo's neighborhoods.",
    intro: "Largo is the heart of mid-Pinellas, full of family neighborhoods with screened-in pools that see daily use. We provide reliable weekly pool cleaning and water chemistry care throughout the city.",
    local: "Screened enclosures keep out the big debris but trap fine particles and pollen, and Largo's mature tree canopy means chemistry can swing after summer storms. Weekly professional testing keeps it dialed in.",
  },
  {
    slug: "belleair-fl",
    name: "Belleair",
    short: "Careful, detail-focused pool service for Belleair's estate properties.",
    intro: "Belleair's beautiful estate homes often feature larger pools, spas, and mature landscaping — properties where consistent, detail-oriented service matters most.",
    local: "We give Belleair pools the unhurried attention they deserve: thorough brushing, precise chemistry, routine filter care, and equipment checks that protect significant investments.",
  },
  {
    slug: "belleair-bluffs-fl",
    name: "Belleair Bluffs",
    short: "Weekly pool care just off the Intracoastal in Belleair Bluffs.",
    intro: "Belleair Bluffs may be one of Pinellas County's smallest cities, but its neighborhoods near the Intracoastal are full of well-loved backyard pools.",
    local: "Proximity to the water means humidity and salt in the air year-round. We keep Bluffs pools balanced and equipment protected with dependable weekly visits.",
  },
  {
    slug: "seminole-fl",
    name: "Seminole",
    short: "Trusted weekly pool service for Seminole families.",
    intro: "Seminole is pool country — family neighborhoods from Lake Seminole to the Pinellas Trail where the backyard pool is the center of summer. We keep those pools swim-ready with reliable weekly service.",
    local: "Afternoon thunderstorms and heavy weekend use are the norm here. Our weekly testing and balancing keeps Seminole water clear through the longest, hottest months of the year.",
  },
  {
    slug: "st-petersburg-fl",
    name: "St. Petersburg",
    short: "Pool cleaning and care across St. Pete, from Old Northeast to the Skyway.",
    intro: "From the historic streets of Old Northeast to newer neighborhoods near the Skyway, St. Petersburg is one of our core service areas for weekly residential pool care.",
    local: "St. Pete's older pools often come with older equipment and finishes that benefit from a professional eye. We service pools across the city and flag equipment issues early, before they become expensive.",
  },
  {
    slug: "st-pete-beach-fl",
    name: "St. Pete Beach",
    short: "Gulf-front pool care for St. Pete Beach homes.",
    intro: "St. Pete Beach pools live in one of the toughest environments in Florida — direct salt air, wind-driven sand, and intense sun that burns through chlorine fast.",
    local: "We service residential pools across St. Pete Beach with chemistry and equipment care tailored to Gulf-front conditions, so your pool stays clear no matter what the breeze brings in.",
  },
  {
    slug: "madeira-beach-fl",
    name: "Madeira Beach",
    short: "Weekly pool service for Mad Beach homes and cottages.",
    intro: "Madeira Beach's mix of year-round homes and seasonal properties all need the same thing: a pool that's clear and ready whenever you are.",
    local: "Coastal corrosion is real on the beach — we keep a close eye on heaters, pumps, and salt systems so small issues don't turn into mid-summer breakdowns.",
  },
  {
    slug: "redington-beach-fl",
    name: "Redington Beach",
    short: "Quiet, dependable pool care for Redington Beach residents.",
    intro: "Redington Beach is a residential beach community where homeowners value service providers who show up and do the job right. That's exactly how we work.",
    local: "We provide weekly cleaning, water chemistry, and equipment care for Redington Beach pools, with the same consistent service day and clear communication we bring everywhere.",
  },
  {
    slug: "indian-rocks-beach-fl",
    name: "Indian Rocks Beach",
    short: "Pool service for IRB's beach cottages and family homes.",
    intro: "Indian Rocks Beach packs a lot of pools into its laid-back streets — from classic beach cottages to newer builds along the Intracoastal.",
    local: "Sand, sunscreen, and salt air put constant pressure on IRB pool water and filters. Our weekly service keeps chemistry balanced and filtration running clean.",
  },
  {
    slug: "indian-shores-fl",
    name: "Indian Shores",
    short: "Reliable pool care along Gulf Boulevard in Indian Shores.",
    intro: "Indian Shores homeowners enjoy some of the best waterfront living in Pinellas County — and pools that need care matched to a coastal environment.",
    local: "We serve Indian Shores with dependable weekly visits, professional water testing, and honest equipment assessments you can trust.",
  },
  {
    slug: "treasure-island-fl",
    name: "Treasure Island",
    short: "Weekly pool service across Treasure Island's waterfront neighborhoods.",
    intro: "From the wide sands of the Gulf side to the canals of the Isle of Palms, Treasure Island homes are built around the water — and the backyard pool is no exception.",
    local: "Waterfront pools collect wind-blown debris and fight constant evaporation that concentrates chemistry. We manage it all with consistent weekly care.",
  },
  {
    slug: "safety-harbor-fl",
    name: "Safety Harbor",
    short: "Pool service beneath Safety Harbor's famous tree canopy.",
    intro: "Safety Harbor's beautiful oak canopy is part of what makes the city special — and part of what makes its pools a challenge. Leaves, pollen, and shade all change how a pool behaves.",
    local: "We tailor chemistry and cleaning to Safety Harbor's shaded, debris-heavy pools, keeping water clear even when the oaks are dropping.",
  },
  {
    slug: "dunedin-fl",
    name: "Dunedin",
    short: "Dependable pool care from downtown Dunedin to the causeway.",
    intro: "Dunedin's established neighborhoods are full of well-loved pools, many of them older plaster pools that reward careful, professional chemistry management.",
    local: "Whether you're near downtown, along the Trail, or out toward Honeymoon Island, we bring the same reliable weekly service and detailed communication to every Dunedin pool.",
  },
  {
    slug: "palm-harbor-fl",
    name: "Palm Harbor",
    short: "Weekly pool service for Palm Harbor's family neighborhoods.",
    intro: "Palm Harbor's larger family pools and screened lanais — from Innisbrook to East Lake — are some of the busiest backyard pools in north Pinellas.",
    local: "Heavy use and long swim seasons mean chemistry has to be managed, not guessed at. We keep Palm Harbor pools balanced, clean, and ready every single week.",
  },
  {
    slug: "tarpon-springs-fl",
    name: "Tarpon Springs",
    short: "Pool care for northern Pinellas, from the Sponge Docks to the lakes.",
    intro: "Tarpon Springs anchors the top of Pinellas County, with pools ranging from in-town bungalows to larger properties near the Anclote River and the area's many lakes.",
    local: "We serve Tarpon Springs with the same dependable weekly routes as the rest of the county — professional water chemistry, careful cleaning, and clear communication after every visit.",
  },
  {
    slug: "tierra-verde-fl",
    name: "Tierra Verde",
    short: "Premium pool service for Tierra Verde's waterfront homes and estates.",
    intro: "Tierra Verde sits at the very southern tip of Pinellas County — an island community of waterfront homes between the Sunshine Skyway and Fort De Soto Park. Pools here aren't an afterthought; they're the centerpiece of the backyard, and they deserve service to match.",
    local: "Living between Tampa Bay and the Gulf means constant salt air and breeze off the water — which drives evaporation, concentrates chemistry, and wears equipment faster than inland pools. Upscale finishes, attached spas, and salt systems are the norm on the island, and our CPO certified care is built for exactly that.",
    note: "Received one of our mailers? That's us — we're investing in Tierra Verde this season. Mention the mailer when you call or request your quote and we'll get you taken care of fast.",
  },
];

export const findLocation = (slug) => LOCATIONS.find((l) => l.slug === slug);
